import { cropImage } from "@brightsites/flow-core/lib/utils/cropImage"

export function optimiseImage(apiUrl: string, cropData: object, imageWidth: number = 1200): string {
    const cropWidth = Math.min(imageWidth, 1200);
    const imageUrl = `${apiUrl}?${cropImage(cropData)}width=${cropWidth}`;
    return imageUrl.replace(/&amp;/g, '&');
}